import { render, staticRenderFns } from "./SavedApplications.vue?vue&type=template&id=3387b196&"
import script from "./SavedApplications.vue?vue&type=script&lang=js&"
export * from "./SavedApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports